﻿import { FC } from 'react';
import { MAIN_NAV_ITEMS } from '../../config/routes';

export interface NavigationProps {
  currentPath: string;
  onNavigate: (path: string) => void;
  isMobile?: boolean;
}

export const Navigation: FC<NavigationProps> = ({ currentPath, onNavigate, isMobile = false }) => {
  return (
    <nav
      aria-label={isMobile ? 'Mobile Navigation' : 'Main Navigation'}
      style={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        gap: isMobile ? '0.75rem' : '1.25rem',
        alignItems: isMobile ? 'flex-start' : 'center',
        width: isMobile ? '100%' : 'auto'
      }}
    >
      {MAIN_NAV_ITEMS.map(item => {
        const isActive = currentPath === item.path;
        return (
          <button
            key={item.path}
            type="button"
            onClick={() => onNavigate(item.path)}
            aria-current={isActive ? 'page' : undefined}
            style={{
              background: 'none',
              border: 'none',
              padding: isMobile ? '0.75rem 0.5rem' : '0.5rem 0.25rem',
              fontSize: isMobile ? '1.05rem' : '0.9375rem',
              fontWeight: isActive ? 700 : 500,
              color: isActive ? 'var(--color-brand-primary)' : 'var(--color-navy-dark)',
              borderBottom: !isMobile && isActive ? '2px solid var(--color-brand-primary)' : '2px solid transparent',
              borderLeft: isMobile && isActive ? '3px solid var(--color-brand-primary)' : '3px solid transparent',
              paddingLeft: isMobile && isActive ? '0.75rem' : isMobile ? '0.5rem' : '0.25rem',
              cursor: 'pointer',
              fontFamily: 'inherit',
              width: isMobile ? '100%' : 'auto',
              textAlign: 'left'
            }}
          >
            {item.name}
          </button>
        );
      })}
    </nav>
  );
};

